// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"ReportButton_genericButton__3oSGe","icon":"ReportButton_icon__3lXuf","baseline":"ReportButton_baseline__by4-F","buttonText":"ReportButton_buttonText__dJy7Q"};